import { CheckCircle2 } from 'lucide-react';

/**
 * A pílula com um dado já confirmado e o atalho para corrigi-lo. Usada nos
 * passos do canal e do código (duas repetições pedem extração — CLAUDE.md,
 * "Regras de interface", item 1).
 */
export function ChipDeResumo({
  rotulo,
  valor,
  aoAlterar,
}: {
  rotulo: string;
  valor: string;
  aoAlterar?: () => void;
}) {
  return (
    <span className="inline-flex max-w-full items-center gap-1.5 rounded-full border border-success/30 bg-success/5 px-2.5 py-1 text-xs">
      <CheckCircle2 aria-hidden="true" className="h-3 w-3 shrink-0 text-success" />
      <span className="text-muted-foreground">{rotulo}</span>
      <span className="min-w-0 truncate font-mono font-medium text-foreground">{valor}</span>
      {aoAlterar && (
        <button
          type="button"
          onClick={aoAlterar}
          aria-label={`Alterar ${rotulo}`}
          className="ml-1 rounded-sm text-link underline underline-offset-2 hover:no-underline focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background"
        >
          alterar
        </button>
      )}
    </span>
  );
}
